import React from 'react'
import { Route } from 'react-router-dom'
import FAQs from './FAQs'

import { faqsRoot } from "../../../constants/routePaths"

const FAQsRoute = [
  <Route
    key="FAQs"
    exact path={faqsRoot}
    component={FAQs}
  />,
];

export default FAQsRoute